import moment from 'moment';
import { Link } from 'react-router';
import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { Box, Column, Row } from '~/commonComponents';
import { UserProfession } from '~/enums/UserProfession';
import { IProfessionalCardUser } from '../../interfaces';
import { ProfessionalRating } from '../ProfessionalRating';

interface IProfessionalCardDetailsProps {
  user: IProfessionalCardUser;
}

export const ProfessionalCardDetailsLegacy = ({ user }: IProfessionalCardDetailsProps) => {
  const { id, fullname, datetime, profession, rating, isAvailable } = user;
  const isToday = moment(datetime).isSame(moment(), 'day');
  const unavailableColorText = isAvailable ? colors.neutral[500] : colors.neutral[300];

  return (
    <Column justifyContent="center" marginLeft={24}>
      <Row alignItems="center" gap={8}>
        <Typography
          as="span"
          bold
          size="heading_4"
          numberOfLines={1}
          style={{ maxWidth: 175, opacity: isAvailable ? 1 : 0.5 }}
        >
          {fullname}
        </Typography>

        <Row alignItems="center" justifyContent="center" gap={7}>
          <ProfessionalRating rating={rating} isAvailable={isAvailable} />
          <Box height={20} width={2} backgroundColor={colors.neutral[600]} />
          {isAvailable ? (
            <Link to={`/dashboard/professional/${id}`} style={{ textDecoration: 'none' }}>
              <Typography as="span" bold color={colors.secondary[500]} size="heading_4">
                Profile
              </Typography>
            </Link>
          ) : (
            <Typography as="span" bold color={colors.secondary[200]} size="heading_4">
              Profile
            </Typography>
          )}
        </Row>
      </Row>
      <Column>
        <Typography as="span" color={unavailableColorText}>
          {UserProfession.getName(profession || '')}
        </Typography>
        {isToday ? (
          <Typography as="span" bold color={unavailableColorText}>
            Working:{' '}
            <Typography
              as="span"
              color={isAvailable ? colors.primary[500] : colors.primary[200]}
              style={{ fontWeight: 500 }}
            >
              TODAY
            </Typography>
          </Typography>
        ) : (
          <Typography as="span" bold color={unavailableColorText}>
            Worked on:{' '}
            <Typography
              as="span"
              color={unavailableColorText}
              style={{
                textTransform: 'capitalize',
              }}
            >
              {moment(datetime).format('ddd, MMM DD, YYYY')}
            </Typography>
          </Typography>
        )}
      </Column>
    </Column>
  );
};
